// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import { buttonStyles } from "../../styles/buttonStyles";
import MultiLineStrings from "./MultiLineStrings";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  flagWrapper: {
    background: theme.palette.primary.third,
    borderRadius: "10px",
    color: theme.palette.primary.contrastText,
    width: "100%",
    padding: "24px 20px",
    lineHeight: "30px"
  },
  verticalCenter: {
    marginTop: "15%"
  },
  flagText: {
    textAlign: "center"
  },
  flagTitle: {
    fontSize: "1.875rem",
    fontWeight: "800",
    lineHeight: "60px"
  },
  flagContent: {
    whiteSpace: "pre-wrap"
  },
  button: {
    marginTop: "15px"
  },
  checkMark: {
    width: "100px",
    display: "block",
    margin: "0 auto"
  },
  "@keyframes dash": {
    from: {
      strokeDashoffset: 1000
    },
    to: {
      strokeDashoffset: 0
    }
  },
  "@keyframes dashCheck": {
    from: {
      strokeDashoffset: -100
    },
    to: {
      strokeDashoffset: 900
    }
  },
  circle: {
    fill: "none",
    stroke: "#3a9d48",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeDasharray: 1000,
    strokeDashoffset: 0,
    animationName: "dash",
    animationDuration: "0.9s",
    animationDelay: "0.35s",
    animationTimingFunction: "ease-in-out",
    animationFillMode: "forwards",
    animationIterationCount: "initial"
  },
  check: {
    fill: "none",
    stroke: "#3a9d48",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: 1000,
    strokeDashoffset: -100,
    animationName: "dashCheck",
    animationDuration: "0.9s",
    animationDelay: "0.55s",
    animationTimingFunction: "ease-in-out",
    animationFillMode: "forwards",
    animationIterationCount: "initial"
  },
  "@supports (-ms-ime-align:auto)": {
    /*Edge*/
    check: {
      strokeDashoffset: 0
    }
  },
  "@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)": {
    /*IE 10, 11*/
    check: {
      strokeDashoffset: 0
    }
  }
});

type CompleteMessageClassesType = {
  ...ButtonStylesClassesType,
  flagWrapper: DictionaryType,
  flagText: DictionaryType,
  flagTitle: DictionaryType,
  flagContent: DictionaryType,
  verticalCenter: DictionaryType,
  button: DictionaryType,
  checkMark: DictionaryType,
  circle: DictionaryType,
  check: DictionaryType
};

type CompleteMessagePropsType = {
  classes: CompleteMessageClassesType,
  title: string,
  content: string,
  isPageCenter: boolean,
  outerStyle?: DictionaryType,
  onClick?: Function
};

class CompleteMessage extends Component<CompleteMessagePropsType, *> {
  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div
        className={classNames(
          classes.flagWrapper,
          this.props.isPageCenter && classes.verticalCenter
        )}
      >
        <div className={classes.flagText}>
          <span className={classes.flagTitle}>{this.props.title}</span>
          <br />
          <svg viewBox="0 0 130.2 130.2" className={classes.checkMark}>
            <circle className={classes.circle} cx="65.1" cy="65.1" r="60.1" />
            <polyline
              className={classes.check}
              points="100.2,40.2 51.5,88.8 29.8,67.5 "
            />
          </svg>
          <div className={classes.flagContent}>
            <MultiLineStrings val={this.props.content} isBrBreak />
          </div>
          {this.props.onClick && (
            <Button
              color="inherit"
              variant="contained"
              type="button"
              className={classNames(classes.lightBtn, classes.button)}
              onClick={this.props.onClick}
            >
              OK
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CompleteMessage);
